export default "__VITE_ASSET__BRbwC8uF__"